var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints, CommonConstant, platformIconPath } from '../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { CampaignInfluencerSearch } from '../../../models/campaign';
import { BackendHttpService } from '../../core/backend-http.service';
import { Router } from '@angular/router';
import { StringUtils } from '../../utils/string.utils';
import { ValidationHandlerService } from '../../core/validation-handler.service';
import { InfluencerCampaign } from '../../../models/influencer-campaign';
import { CommonService } from '../common/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Influencer } from '../../../models/influencer';
var CampaignService = /** @class */ (function (_super) {
    __extends(CampaignService, _super);
    function CampaignService(router, translate, validationHandler, commonService, http) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.validationHandler = validationHandler;
        _this.commonService = commonService;
        _this.http = http;
        return _this;
    }
    CampaignService.prototype.getCampaignFullListForCompany = function (companyId, isCampaignHistory) {
        var apiUrl = apiEndpoints.campaigns.replace(':companyId', companyId);
        var status = isCampaignHistory ? 2 : 1;
        return this.get(apiUrl + ("?status=" + status)).map(function (res) { return res ? res.data : null; });
    };
    CampaignService.prototype.searchCampaigns = function (companyId, isCampaignHistory, searchValue) {
        var apiUrl = apiEndpoints.searchCampaigns;
        var params = {
            companyId: companyId,
            searchValue: searchValue,
            campaignStatus: isCampaignHistory ? 'Archived' : 'Active'
        };
        return this.get(apiUrl, params).map(function (res) { return res ? res.data : null; });
    };
    CampaignService.prototype.getCampaignShortListForCompany = function (companyId) {
        var apiUrl = apiEndpoints.getCampaignShortListForCompany;
        var params = {
            companyId: companyId,
            status: 1
        };
        return this.get(apiUrl, params).map(function (res) { return res ? res.data : []; });
    };
    CampaignService.prototype.getInfluencerByCampaign = function (campaignId) {
        return this.get(apiEndpoints.campaignInfluencers.replace(':campaignId', campaignId)).map(function (res) { return res.data; });
    };
    CampaignService.prototype.deleteCampaign = function (campaignId) {
        return this.delete(apiEndpoints.deleteCampaign + '/' + campaignId);
    };
    /**
     * this method is used to add an influencer to Campaign
     * @param {AddInfluencersCampaign} addInfluencerToCampaign
     * @returns {Observable<any>}
     */
    CampaignService.prototype.addInfluencerToCampaign = function (influencerToAdd) {
        return this.post(apiEndpoints.addInfluencerToCampaign, influencerToAdd);
    };
    CampaignService.prototype.getSelectableCampaignTerms = function (companyid, campaignType) {
        return this.get(apiEndpoints.getSelectableCampaignTerms + '?companyId=' + companyid + '&campaignType=' + campaignType)
            .map(function (resp) { return resp.data; });
    };
    CampaignService.prototype.addNewCampaign = function (campaign) {
        var errors = this.validateCampaign(campaign);
        if (errors.length > 0) {
            this.validationHandler.shouldDisplayErrors(true);
            this.validationHandler.updateErrors(errors);
            throw new Error('add_new_campaign_error');
        }
        else {
            return this.post(apiEndpoints.addNewCampaign, campaign)
                .map(function (resp) { return resp.data; });
        }
    };
    CampaignService.prototype.updateCampaign = function (campaign) {
        var errors = this.validateCampaign(campaign);
        if (errors.length > 0) {
            this.validationHandler.shouldDisplayErrors(true);
            this.validationHandler.updateErrors(errors);
            return Observable.throw(new Error('update_campaign_error'));
        }
        else {
            return this.post(apiEndpoints.updateCampaign, campaign)
                .map(function (resp) { return resp.data; });
        }
    };
    CampaignService.prototype.validateCampaign = function (campaign) {
        var errors = [];
        if (!campaign.brief || StringUtils.trim(campaign.brief) === '') {
            errors.push({ name: 'campaign_brief',
                message: this.translate.instant('campaigns.validation.brief_madatory') });
        }
        else if (campaign.brief.length > 21844) {
            errors.push({ name: 'campaign_brief',
                message: this.translate.instant('campaigns.validation.brief_too_long') });
        }
        if (campaign.keywordIds.length === 0) {
            errors.push({ name: 'campaign_keywords',
                message: this.translate.instant('campaigns.validation.mention_madatory') });
        }
        if (campaign.additionalInfo && campaign.additionalInfo.length > 21844) {
            errors.push({ name: 'campaign_additional_info',
                message: this.translate.instant('campaigns.validation.brief_too_long') });
        }
        return errors;
    };
    CampaignService.prototype.uploadFile = function (formData) {
        return this.postRaw(apiEndpoints.uploadFile, formData, { headers: null })
            .map(function (resp) { return resp.data; });
    };
    CampaignService.prototype.getCampaignFiles = function (campaignId) {
        return this.get(apiEndpoints.getCampaignFiles.replace(':CAMPAIGN_ID', campaignId))
            .map(function (resp) { return resp.data; });
    };
    CampaignService.prototype.getCampaignTerms = function (campaignId) {
        return this.get(apiEndpoints.getCampaignTerms.replace(':CAMPAIGN_ID', campaignId))
            .map(function (resp) { return resp.data; });
    };
    CampaignService.prototype.getCampaign = function (campaignId, companyId) {
        return this.get(apiEndpoints.getCampaign + '/' + campaignId, { companyId: companyId }).map(function (res) { return res.data; });
    };
    CampaignService.prototype.getCampaignOfInfluencer = function (influencerId, campaignId) {
        return this.get(apiEndpoints.getAllCampaignsForInfluencer, {
            influencer_id: influencerId
        }).map(function (res) { return Array.isArray(res.data) ? res.data.filter(function (cp) { return cp.campaign_id === campaignId; }) : []; });
    };
    CampaignService.prototype.parseMentions = function (keyword) {
        // regression use to detect a keywork is matching with url
        var UrlPattern = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
        var type;
        if (!UrlPattern.test(keyword) && keyword.indexOf('#') !== 0) {
            type = 1 /* Keyword */;
        }
        else if (UrlPattern.test(keyword) && keyword.indexOf('#') !== 0) {
            type = 2 /* URL */;
        }
        else if (!UrlPattern.test(keyword) && keyword.indexOf('#') === 0) {
            type = 3 /* Hashtag */;
        }
        return {
            keyword: StringUtils.trim(keyword),
            keywordType: type,
            language: []
        };
    };
    CampaignService.prototype.getAvailableCampaignsToAddPost = function (companyId) {
        return this.get(apiEndpoints.getAvailableCampaignsToAddPost.replace(':companyId', companyId)).map(function (res) {
            return res && res.data ? res.data.map(function (item) { return Object.assign({}, item, {
                campaign_id: item.id,
                campaign_name: item.name
            }); }) : [];
        });
    };
    /**
     * this method is used to add posts to Campaign
     * @param {posts: [{postUrlHash: <url hash of post>},…]} postParams
     * @returns {Observable<any>}
     */
    CampaignService.prototype.addPostsToCampaign = function (campaignId, postParams) {
        return this.post(apiEndpoints.addPostsToCampaign.replace(':campaignId', campaignId), { posts: postParams });
    };
    /**
     * get campaign post status
     * @param campaignId
     * @param postUrlHashs
     * @returns {Observable<any>}
     */
    CampaignService.prototype.checkPostStatus = function (campaignId, postUrlHashs) {
        return this.post(apiEndpoints.getPostStatus.replace(':campaignId', campaignId), postUrlHashs)
            .map(function (res) { return res && res.data ? res.data : null; });
    };
    /**
     * this method is used to delete an Influencer from Campaign
     * @param {campaignInfluencerId}
     * @returns {Observable<any>}
     */
    CampaignService.prototype.deleteInfluencerFromCampaign = function (campaignInfluencerId) {
        return this.delete(apiEndpoints.deleteInfluencerFromCampaign + campaignInfluencerId);
    };
    /**
     * validate a file before uploading
     * @param file
     */
    CampaignService.prototype.validateMaterialUploadFile = function (file) {
        var fileSize = file.size / 1024 / 1024;
        if (CommonConstant.MAX_UPLOADED_FILE_SIZE < fileSize) {
            throw new Error('common.file_size_too_large');
        }
    };
    CampaignService.prototype.downloadCampaignMaterials = function (fileData) {
        var _headers = new HttpHeaders();
        _headers = _headers.set('Content-Type', "" + fileData.contentType);
        return this.http.get(fileData.content, { responseType: 'blob', headers: _headers, params: fileData.name });
    };
    /**
     * this method is used to delete custom term
     * @param {termId}
     * @returns {Observable<any>}
     */
    CampaignService.prototype.deleteTerm = function (id) {
        return this.delete(apiEndpoints.deleteCampaignTerm + id)
            .map(function (resp) { return resp.data; });
    };
    /**
     * this method is used to add custom term
     * @param {data}
     * @returns {Observable<any>}
     */
    CampaignService.prototype.addCustomTerm = function (data) {
        return this.post(apiEndpoints.addCustomTerm, data)
            .map(function (resp) { return resp.data; });
    };
    /**
     * this method is used to edit custom term
     * @param {data}
     * @returns {Observable<any>}
     */
    CampaignService.prototype.editCustomTerm = function (data, termId) {
        return this.put(apiEndpoints.updateCampaignTerm + termId, data)
            .map(function (resp) { return resp.data; });
    };
    CampaignService.prototype.validateCustomTerm = function (term) {
        var errors = [];
        if (!term.summary || StringUtils.trim(term.summary) === '') {
            errors.push({ name: 'headline',
                message: this.translate.instant('campaigns.term.headline_madatory') });
        }
        if (!term.body || StringUtils.trim(term.body) === '') {
            errors.push({ name: 'body_text',
                message: this.translate.instant('campaigns.term.body_text_madatory') });
        }
        return errors;
    };
    CampaignService.prototype.downloadInvoiceDocument = function (fileId, fileName) {
        return this.getImage(apiEndpoints.getUploadFile + '/' + fileId, { fileName: fileName });
    };
    /**
     * get status of post list based on urlHash
     * @param campaignId
     * @param postUrlHashs
     * @returns {Observable<any>}
     */
    CampaignService.prototype.getPostStatus = function (campaignId, postUrlHashs) {
        return this.post(apiEndpoints.getPostStatus.replace(':campaignId', campaignId.toString()), {
            posts: postUrlHashs.map(function (h) { return ({
                urlHash: h
            }); })
        }).map(function (res) { return res && res.data ? res.data : null; });
    };
    /**
     * Delete a list of post based on {urlHash, channelId}
     * @param {number} campaignId
     * @param {DeletePostCampaign[]} posts
     * @returns {Observable<any>}
     */
    CampaignService.prototype.deletePostFromCampaign = function (campaignId, posts) {
        return this.post(apiEndpoints.deletePost.replace(':campaignId', campaignId.toString()), {
            posts: posts
        }).map(function (res) { return res && res.data ? res.data : null; });
    };
    /**
     * mapping ES data from WS to Campaign Influencer model
     * @param influencer
     * @returns {InfluencerCampaign}
     */
    CampaignService.prototype.mapInfluencerCampaign = function (influencer) {
        var influencerCamp = new InfluencerCampaign();
        influencerCamp.campaign_influencer_id = influencer.campaignInfluencerId;
        influencerCamp.country = influencer.country;
        influencerCamp.influencer_id = influencer.influencerId;
        influencerCamp.influencer_name = influencer.influencerName;
        influencerCamp.campaign_influencer_status = influencer.status;
        influencerCamp.influencer_profile_picture = influencer.profileImage;
        influencerCamp.country_code = influencer.country.code;
        influencerCamp.campaign_influencer_engagement = {
            value: influencer.engagement,
            percent: null
        };
        influencerCamp.campaign_influencer_impact = {
            value: influencer.impact,
            percent: null
        };
        influencerCamp.campaign_influencer_reach = {
            value: influencer.reach,
            percent: null
        };
        influencerCamp.campaign_influencer_number_of_post = influencer.totalPost;
        influencerCamp.campaign_influencer_platformBlogs = this.hasPlatform(platformIconPath.blogs.id, influencer);
        influencerCamp.campaign_influencer_platformFacebook = this.hasPlatform(platformIconPath.facebook.id, influencer);
        influencerCamp.campaign_influencer_platformInstagram = this.hasPlatform(platformIconPath.instagram.id, influencer);
        influencerCamp.campaign_influencer_platformPinterest = this.hasPlatform(platformIconPath.pinterest.id, influencer);
        influencerCamp.campaign_influencer_platformSnapchat = this.hasPlatform(platformIconPath.snapchat.id, influencer);
        influencerCamp.campaign_influencer_platformTwitter = this.hasPlatform(platformIconPath.twitter.id, influencer);
        influencerCamp.campaign_influencer_platformYoutube = this.hasPlatform(platformIconPath.youtube.id, influencer);
        influencerCamp.campaign_influencer_platformTikTok = this.hasPlatform(platformIconPath.tiktok.id, influencer);
        return influencerCamp;
    };
    CampaignService.prototype.updateCampaignDetailsData = function (camp, influencerList) {
        var _this = this;
        if (!camp) {
            return null;
        }
        camp.isFetchingKpi = false;
        camp.influencers = influencerList.map(function (infl) { return _this.mapInfluencerCampaign(infl); });
        // reduce to calculate campaign global KPI
        var campaignKpis = camp.influencers.reduce(
        // Reduce function
        function (accumulator, infl_kpi) { return ({
            impression: accumulator.impression,
            engagement: accumulator.engagement + infl_kpi.campaign_influencer_engagement.value,
            reach: accumulator.reach + infl_kpi.campaign_influencer_reach.value,
            totalPost: accumulator.totalPost + infl_kpi.campaign_influencer_number_of_post
        }); }, 
        // Initial state of accumulator
        {
            impression: 0,
            engagement: 0,
            reach: 0,
            totalPost: 0,
        });
        if (campaignKpis) {
            camp.engagement = campaignKpis.engagement;
            camp.impression = campaignKpis.impression;
            camp.reach = campaignKpis.reach;
            camp.impact = (campaignKpis.engagement / campaignKpis.reach).toFixed(2);
        }
        camp.numberOfInfluencers = camp.influencers.length;
        camp.numberOfPosts = campaignKpis.totalPost;
    };
    CampaignService.prototype.updateCampaignDetailsDataByPostList = function (camp) {
        if (!camp) {
            return null;
        }
        camp.isFetchingKpi = false;
        // reduce to calculate campaign global KPI
        var campaignPostKpi = camp.posts.reduce(
        // Reduce function
        function (accumulator, postkpi) { return ({
            impression: accumulator.impression + postkpi.impression,
            engagement: accumulator.engagement + postkpi.engagement,
            reach: accumulator.reach + postkpi.reach
        }); }, 
        // Initial state of accumulator
        {
            impression: 0,
            engagement: 0,
            reach: 0,
        });
        if (campaignPostKpi) {
            camp.engagement = campaignPostKpi.engagement;
            camp.impression = campaignPostKpi.impression;
            camp.reach = campaignPostKpi.reach;
            camp.impact = (campaignPostKpi.engagement / campaignPostKpi.reach).toFixed(2);
        }
        camp.numberOfPosts = camp.posts.length;
    };
    CampaignService.prototype.hasPlatform = function (platformId, influencer) {
        if (!Array.isArray(influencer.platformIds) || influencer.platformIds.length === 0) {
            return false;
        }
        return influencer.platformIds.indexOf(platformId) >= 0;
    };
    CampaignService.prototype.getCampaignPostDailyKpis = function (campaignInfluencerId, fromDate, toDate) {
        var _this = this;
        var params = {
            fromDate: fromDate,
            toDate: toDate
        };
        return this.get(apiEndpoints.campaignPostDailyKpis.replace(':campaignInfluencerId', campaignInfluencerId.toString()), params).map(function (res) {
            return _this.commonService.normalizeDataForActivityLineChart(res.data.data);
        });
    };
    CampaignService.prototype.archiveCampaign = function (campaignId) {
        return this.post(apiEndpoints.archiveCampaign, {
            id: campaignId
        }).map(function (res) { return console.log(res.data); });
    };
    CampaignService.prototype.unarchiveCampaign = function (campaignId) {
        return this.post(apiEndpoints.unarchiveCampaign, {
            id: campaignId
        }).map(function (res) { return res.data; });
    };
    CampaignService.prototype.searchCampaignInfluencers = function (searchFilter, campaignId) {
        var searchFilterOrderBy = searchFilter.orderBy ? searchFilter.orderBy.toLowerCase() : CommonConstant.SORT_BY_REACH;
        searchFilter.isAscendingOrder = searchFilter.orderBy && searchFilter.isAscendingOrder ? searchFilter.isAscendingOrder : CommonConstant.DEFAULT_ASCENDING_ORDER_SORT_BY;
        searchFilter.limit = searchFilter.limit ? searchFilter.limit : 0;
        var mappedSearchFilter = this.mappingCampaignInfluencerSearch(searchFilter);
        var result = this.post(apiEndpoints.searchCampaignInfluencer.replace(':campaignId', campaignId)
            + ("?orderBy=" + searchFilterOrderBy + "&isAscendingOrder=" + searchFilter.isAscendingOrder + "&limit=" + searchFilter.limit), JSON.stringify(mappedSearchFilter));
        return result.map(function (res) { return res && res.data ? res.data : []; });
    };
    CampaignService.prototype.mappingCampaignInfluencerSearch = function (searchFilter) {
        var searchParam = new CampaignInfluencerSearch();
        searchParam.countries = searchFilter.selectedCountry ? [searchFilter.selectedCountry] : [];
        searchParam.genders = searchFilter.selectedGender ? [searchFilter.selectedGender] : searchFilter.selectedGender === 0 ? [0] : [];
        searchParam.platforms = searchFilter.selectedPlatform ? [searchFilter.selectedPlatform] : [];
        searchParam.searchString = searchFilter.searchString ? searchFilter.searchString : null;
        searchParam.reachFrom = searchFilter.reachFrom ? searchFilter.reachFrom : null;
        searchParam.reachTo = searchFilter.reachTo ? searchFilter.reachTo : null;
        searchParam.engagementFrom = searchFilter.engagementFrom ? searchFilter.engagementFrom : null;
        searchParam.engagementTo = searchFilter.engagementTo ? searchFilter.engagementTo : null;
        searchParam.impactFrom = searchFilter.impactFrom ? searchFilter.impactFrom : null;
        searchParam.impactTo = searchFilter.impactTo ? searchFilter.impactTo : null;
        return searchParam;
    };
    CampaignService.prototype.getCampaignInfluencerPostCount = function (campaignId, periodRange) {
        return this.get(apiEndpoints.getCampaignInfluencerPostCount.replace(':campaignId', campaignId) + ("?period=" + periodRange)).map(function (res) { return res.data; });
    };
    CampaignService.prototype.mapNewAddedInfluencer = function (newInfluencerData, filteredNewAcceptInfluencer) {
        if (!newInfluencerData) {
            return;
        }
        return newInfluencerData.map(function (itemData) {
            var newAddedInfluencer = new Influencer();
            newAddedInfluencer.country = itemData.country ? itemData.country : CommonConstant.INTERNATIONAL_COUNTRY_DATA;
            newAddedInfluencer.influencer_id = itemData.influencer_id;
            newAddedInfluencer.influencer_name = itemData.influencer_name;
            newAddedInfluencer.profilePicture = itemData.influencer_profile_picture;
            newAddedInfluencer.influencer_image = itemData.influencer_profile_picture;
            newAddedInfluencer.country_code = itemData.country && itemData.country.code ? itemData.country.code : CommonConstant.INTERNATION_COUNTRY_CODE.toUpperCase();
            newAddedInfluencer.engagement = itemData.engagement;
            newAddedInfluencer.impact = filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length === 0 ? 0 : itemData.impact && isNaN(itemData.impact) === false ? itemData.impact * 100 : 0;
            newAddedInfluencer.reach = filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length === 0 ? 0 : itemData.reach;
            newAddedInfluencer.numberOfPosts = filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length === 0 ? 0 : itemData.numberOfPosts;
            newAddedInfluencer.campaign_influencer_id = itemData.campaign_influencer_id;
            newAddedInfluencer.influencerStatus = itemData.influencerStatus ? itemData.influencerStatus : null;
            newAddedInfluencer.isNewAdded = true;
            return newAddedInfluencer;
        });
    };
    return CampaignService;
}(BackendHttpService));
export { CampaignService };



// WEBPACK FOOTER //
// ./src/app/services/campaign/campaign.service.ts.pre-build-optimizer.js